define(['underscore','text!./templates/ho-roof-type-select.html'],
    (_,templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    model: '=',
                    otherModel: '=',
                    filterCodes: '='
                },
                controller: ['$scope', ($scope) => {

                    // Assign available values from model object
                    // Replaced options='model.aspects.availableValues' to options='availableValues' (ho-roof-type-select.html) 
                    // to filter the not required values from the dropdown
                    $scope.availableValues = $scope.model.aspects.availableValues;
                    // Check if filterCodes is an array
                    // then remove those values from availableValues
                    if (!_.isUndefined($scope.filterCodes) && _.isArray($scope.filterCodes)){                       

                        $scope.availableValues = _.filter($scope.availableValues, function (typeCode) {

                            return $scope.filterCodes.indexOf(typeCode.code) === - 1;
                        });
                    }
                }]
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/directives/HORoofTypeSelect.js
 **/